import styled from "styled-components";

export const QaContainer = styled.div`
  color: #091427;
  height: 100%;
  width: 77rem;
  margin: 0 auto 50px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media screen and (max-width: 1000px) {
    width: auto;
    padding: 0 15px;
  }
  @media screen and (min-width: 1001px) {
    margin-top: 50px;
  }
`

export const HeaderCentered = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  h2 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    @media screen and (max-width: 1000px) {
      font-size: 1.714285rem;
      text-align: center;
      margin-block-start: 0em;
      margin-block-end: 1.8rem;
    }
  }
`

export const QaInner = styled.div`
  width: 100%;
  padding-top: 28px;
  border-radius: 18px;
  background-color: #FFFFFF;
  box-shadow: 0 5px 16px 0 rgba(8, 15, 52, 0.06);
`